import React, { useState, useEffect } from 'react';
import { Form, Tag,DatePicker,Select } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import './WPAManagementSort.css';
import PropTypes from 'prop-types';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import approveImg from '../../public/img/newMain/Approve.png';
import resetWhite from '../../public/img/newMain/resetWhite.png'
import context from '../../public/js/context';
/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let WPAManagementSort = ({ onOpenChange ,isReset }) => {
    const [form] = Form.useForm();

    const [selectedConditions, setSelectedConditions] = useState({});
    const [sortOptions, setSortOptions] = useState([]);
    const [jobPostModel, setJobPostModel] = useState({});
    /**
     * 标题默认值处理
     */
    useEffect(() => {
        setSortOptions([
            {
                label:"",
                value:""
            },
            {
                label:"WPA ID",
                value:"wpa_appl_id"
            },
            {
                label:"Company",
                value:"company_name"
            },
            {
                label:"Industry Supervisor",
                value:"industry_supervisor_name"
            },
            {
                label:"WIL Hours",
                value:"wil_hours"
            },
            {
                label:"Mark",
                value:"mark"
            },
            {
                label:"Submit Date",
                value:"apply_date"
            },
            {
                label:"Last Update",
                value:"last_updte_dte"
            },
            {
                label:"Sent to IS over 14 days",
                value:"sent_to_is"
            },
            {
                label:"Status",
                value:"wpa_status"
            },
        ])
    }, []);

    useEffect(()=>{
        if(isReset){
            reset()
        }
    },[isReset])
    

    const handleChange = (selectedOption) => {
        form.setFieldValue('orderBy',selectedOption)
    };

    const save = ()=>{
        form.validateFields().then(()=>{
            selectedConditions['wpaStatus'] ? jobPostModel.wpaStatusList = selectedConditions['wpaStatus']:"";
            jobPostModel.startDate =  form.getFieldValue('startDate');
            jobPostModel.endDate =  form.getFieldValue('endDate') ;
            jobPostModel.orderBy = form.getFieldValue('orderBy');
            onOpenChange(false,true,jobPostModel)
        })
    }

    const reset = ()=>{
        setSelectedConditions({});
        form.resetFields()
        setJobPostModel({})
    }

    const close = ()=>{
        onOpenChange(false,false)
    }

    const handleConditionClick = (condition, groupName) => {
        const updatedSelectedConditions = { ...selectedConditions };
        if (!updatedSelectedConditions[groupName]) {
          updatedSelectedConditions[groupName] = [];
        }
    
        const index = updatedSelectedConditions[groupName].indexOf(condition);
        if (index !== -1) {
          // 如果已选中，则移除
          updatedSelectedConditions[groupName].splice(index, 1);
        } else {
          // 如果未选中，则添加
          updatedSelectedConditions[groupName].push(condition);
        }
    
        setSelectedConditions(updatedSelectedConditions);
    };

    const isConditionSelected = (condition, groupName) => {
        if (selectedConditions[groupName]) {
          return selectedConditions[groupName].includes(condition);
        }
        return false;
    };

    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('endDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('startDate')) && Base.afterDate(form.getFieldValue('startDate'), form.getFieldValue('endDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    return (
        <div className='WPAManagementSort'>
            <Form form={form}>
            <div>
                <div className='closePopover'  onClick={close}><CloseCircleOutlined /></div>
                <div className='Title' style={{display:'flex'}}>
                    <span className='lable'>Status :</span>
                    <div className='lableValue'>
                        {context.wpaFormStatusMap.map((item, index) => 
                            <Tag key={index} className={isConditionSelected(item.value, 'wpaStatus') ? 'selected' : 'noSelected'} onClick={() => handleConditionClick(item.value, 'wpaStatus')}>{item.label}</Tag>
                        )}
                    </div>
                </div>
                
                <div className='Title' style={{  marginBottom:'10px',display:'flex'}}>
                    <span className='lable'>Submitted Date :</span>
                    <span style={{display:'flex'}}>
                            <div>
                                <Form.Item
                                    name="startDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                    { validator: (rule, value) => checkStartDate(value) },
                                    ]}>
                                    <DatePicker
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            <span style={{margin:'0px 10px'}}>-</span>
                            <div>
                                <Form.Item
                                    name="endDate"
                                    rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                    { validator: (rule, value) => checkEndDate(value) },
                                    ]}>
                                    <DatePicker 
                                        placeholder=""
                                        className="timeDatePicker"
                                        allowClear={true}
                                        format={Config.dateFormatEn} />
                                </Form.Item>
                            </div>
                            
                       
                    </span>
                </div>
                
                <div className='Title' style={{ marginBottom: '10px', display: 'flex' }}>
                        <span className='lable'>Sort By :</span>
                        <Form.Item
                            name="orderBy"
                        >
                            <Select
                                onChange={handleChange}
                                options={sortOptions}
                            />
                        </Form.Item>
                    </div>
            </div>
            </Form>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={approveImg} />Confirm</div>
                <div className='resetButton' onClick={reset}><img src={resetWhite} />Reset</div>
            </div>
            
        </div>
    )

}
WPAManagementSort.propTypes = {
    onOpenChange: PropTypes.func.isRequired,
    isReset: PropTypes.bool.isRequired,
};
export default WPAManagementSort;